import React from 'react';
import { RenderWidgetProps } from '../types';
import styles from './styles.module.scss';
import {
  ContentsHeading,
  TextWithSubheading,
  ImageWithCaption,
  VideoWithCaption,
  TableSection,
  DocumentDownload,
  RelatedContent,
  KeyMessage,
} from './export_components';

export const RenderBodyWidget: React.FC<RenderWidgetProps> = ({
  cmscomponents,
}) => {
  const data = cmscomponents[0];
  let counter = 1;

  const hasAttachments = data.multipleObjectParentModels.filter(
    (m: any) => m.attachmentModels.length > 0,
  )[0];

  // const hasCardWithImageModels = data.multipleObjectParentModels.filter(
  //   (m: any) => m.cardWithImageModels.length > 0,
  // )[0];

  const tableWithTextImageModels = data.multipleObjectParentModels.filter(
    (m: any) => m.tableWithTextImageModels.length > 0,
  )[0];

  const tableWithTextVideoModels = data.multipleObjectParentModels.filter(
    (m: any) => m.videoGalleryModels.length > 0,
  )[0];

  return (
    <section className={styles['body-widgets-section']}>
      <div>
        {data['contents_heading'] && (
          <ContentsHeading component={data} id={counter++} key={counter} />
        )}

        {data['multipleObjectParentModels'] && tableWithTextImageModels && (
          <TextWithSubheading
            key={++counter}
            multipleObjectParentModels={data.multipleObjectParentModels}
          />
        )}

        {data['multipleObjectParentModels'] && tableWithTextVideoModels && (
          <TextWithSubheading
            key={++counter}
            multipleObjectParentModels={data.multipleObjectParentModels}
          />
        )}

        {/* {data['imageModels'] && (
          <ImageWithCaption key={6} component={data.imageModels} />
        )} */}
        {data['videoUploadModels'] && data.videoUploadModels?.length > 0 && (
          <VideoWithCaption
            key={++counter}
            videoUploadModels={data.videoUploadModels}
          />
        )}

        {/* {data['table_section'] && (
          <div key={ ++counter }>
            <TableSection key={ ++counter } component={data.table_section} />
          </div>
        )} */}

        {data['multipleObjectParentModels'] && hasAttachments && (
          <DocumentDownload
            key={++counter}
            multipleObjectParentModels={data.multipleObjectParentModels}
          />
        )}

        {data['relatedContents'] &&
          data.relatedContents?.length > 0 &&
          data.relatedContents[0]?.multipleObjectParentModels?.length > 0 && (
            <RelatedContent component={data.relatedContents[0]} />
          )}

        {data['key_message'] && (
          <KeyMessage key={++counter} component={data.key_message} />
        )}

        {/* {cmscomponents?.map((component: any, index: number) => {
          console.log('outside if', component);
          const key = `intro-widget-${index}`;

          if (component['contents_heading']) {
            return (
              <ContentsHeading
                component={component}
                id={counter++}
                key={index}
              />
            );
          }

          if (component['multipleObjectParentModels']) {
            return component.multipleObjectParentModels[1].cardWithImageModels.map(
              (item: any, index: any) => (
                <TextWithSubheading key={index} component={item} />
              ),
            );
          }

          if (component['image_with_caption']) {
            return (
              <ImageWithCaption
                key={key}
                component={component.image_with_caption}
              />
            );
          }

          if (component['video_with_caption']) {
            return (
              <VideoWithCaption
                key={key}
                component={component.video_with_caption}
              />
            );
          }

          if (component['table_section']) {
            return (
              <div key={key}>
                <TableSection key={key} component={component.table_section} />
              </div>
            );
          }

          if (component['documents_download']) {
            return (
              <DocumentDownload
                key={key}
                component={component.documents_download}
              />
            );
          }

          if (component['relatedContents']) {
            console.log('inside if', component.relatedContents[0]);
            return (
              <RelatedContent
                key={key}
                component={component.relatedContents[0]}
              />
            );
          }

          if (component['key_message']) {
            return <KeyMessage key={key} component={component.key_message} />;
          }

          return null;
        })} */}
      </div>
    </section>
  );
};
